module.exports = __webpack_public_path__ + "img/blue_144.b88c2e9f.png";